import theme from '@/theme';
import styled from '@emotion/styled';
import { FrameIcon, WidgetIcon } from './ShareModalIcons';
import { EmbedMode } from './types';

const TabsContainer = styled.div`
    border-radius: 8px;
    background: ${theme.colors.black[100]};
    display: flex;
    padding: 4px;
    flex-direction: flex-row;
    align-items: flex-start;
    align-self: stretch;
`;

const Tab = styled.button<{ active: boolean }>`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    flex-direction: flex-row;
    gap: 8px;
    padding: 10px 0;
    border-radius: 8px;
    background-color: ${({ active }) => (active ? '#fff' : 'inherit')};
    border: ${({ active }) => (active ? '1px rgba(0, 0, 0, 0.12) solid' : '1px transparent')};
    font-size: 14px;
    font-weight: 500;
    color: #000;
    cursor: pointer;

    &:hover {
        opacity: 90%;
    }

    &:focus,
    &:active {
        outline: none;
    }
`;

interface Props {
    value: EmbedMode;
    setValue: (next: EmbedMode) => void;
}

export const ModeTabs = ({ value, setValue }: Props) => {
    return (
        <TabsContainer>
            <Tab active={value === 'fabio'} onClick={() => setValue('fabio')}>
                <WidgetIcon active={value === 'fabio'} />
                Widget
            </Tab>
            <Tab active={value === 'full'} onClick={() => setValue('full')}>
                <FrameIcon active={value === 'full'} />
                Frame
            </Tab>
        </TabsContainer>
    );
};
